/**
 * member-request-dialog.js
 */

import React from 'react';
import axios from 'axios';
import { Typography, TextField } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { isValidEmail } from 'utils/user-profile-validation';
import Dialog from 'components/dialog';
import Spinner from 'components/spinner';


const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiDialogContent-root': {
      paddingTop: theme.spacing(3),
    },
    '& .MuiDialogActions-root strong': {
      display: 'flex'
    }
  },
  text: {
    marginBottom: theme.spacing(3)
  }
}));


export default function MemberRequestDialog(props) {
  const {
    isOpen,
    onClose,
    onAddPending,
    onAddMember,
    inputText,
    group,
    options,
    memberEmails,
    pendingEmails
  } = props;
  const classes = useStyles();
  const [email, setEmail] = React.useState('');
  const emailRef = React.useRef();
  const emailLower = email.toLowerCase();
  const [error, setError] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);


  React.useEffect(() => {
    if (isOpen) {
      setError();
      setEmail(inputText);
      setTimeout(() => emailRef.current?.focus());
    }
  }, [isOpen, inputText, setEmail]);


  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      onAttemptOk();
    }
  }


  const onAttemptOk = async () => {
    if (!isValidEmail(email)) {
      setError('Please enter a valid email');
      return;
    } else if (memberEmails.includes(emailLower)) {
      setError('This user is already a group member');
      return;
    } else if (pendingEmails.includes(emailLower)) {
      setError('This user is already a pending member');
      return;
    } else {
      setError();
      const option = options.find(m => m.email.toLowerCase() === emailLower);

      if (option) {
        onAddMember(option);
        onClose();
        return;
      }
    }

    setIsLoading(true);
    try {
      const response = await axios.get(`/groups/${group.id}/member-request?email=${encodeURIComponent(email)}`, { bypassErrorHandling: true });
      if (response.status === 200) {
        onAddPending(response.data);
        onClose();
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setIsLoading(false);
    }
  }


  return (
    <>
      <Dialog
        fullWidth
        maxWidth='xs'
        title='Request Member'
        className={classes.root}
        open={isOpen}
        onClose={onClose}
        okLabel={isLoading ? <Spinner size={25} /> : 'OK'}
        onOk={onAttemptOk}
        children={<>
          <Typography className={classes.text}>
            Type the handler's email below. The recipient will have the option to join this group and become one of your Connected Handlers.
          </Typography>
          <TextField
            fullWidth
            inputRef={emailRef}
            label='Email'
            variant='outlined'
            value={email}
            helperText={error}
            error={Boolean(error)}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={onKeyDown}
          />
        </>}
      />
    </>
  );
}